import {useCallback} from 'react'
import {useDispatch} from 'react-redux'
import {useHistory} from 'react-router-dom'

import {AnalyticsRoutesEnum, RESOURCE_TYPE} from 'interfaces'
import {setAnalyticsDetailFilters} from '../Detail/analyticsDetailAction'

export const useOpenUserDetails = (): ((email: string) => void) => {
  const dispatch = useDispatch()
  const history = useHistory()

  return useCallback(
    (email: string): void => {
      dispatch(
        setAnalyticsDetailFilters({
          resourceType: [RESOURCE_TYPE.Users],
          filterDetails: {userEmail: email},
        }),
      )
      if (history.location.pathname !== AnalyticsRoutesEnum.ANALYTICS_DETAIL) {
        history.push(AnalyticsRoutesEnum.ANALYTICS_DETAIL)
      }
    },
    [dispatch, history],
  )
}
